module.exports = __webpack_public_path__ + "static/img/h27.6cae862.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/h27.jpg
// module id = ExbZ
// module chunks = 0